import { TRIAL_ATTENDANCE_STATUS } from "../../../constants/enrollments";;

/**
 * Resolve o status de presença de um enrollment trial.
 * Suporta tanto o campo novo `attendanceStatus` quanto dados legados
 * onde o `status` foi sobrescrito com PRESENT/ABSENT.
 * 
 * Prioridade:
 * 1. `attendanceStatus` (campo dedicado, novo padrão)
 * 2. `status` com valor PRESENT/ABSENT (dados legados do attendance_service antigo)
 * 3. Fallback: PENDING
 */
export const resolveTrialAttendance = (enrollment) => {
    // Campo novo (padrão pós-refactor)
    if (enrollment.attendanceStatus) {
        return enrollment.attendanceStatus;
    }
    
    // Compatibilidade com dados antigos onde status foi sobrescrito
    if (enrollment.status === "PRESENT") return TRIAL_ATTENDANCE_STATUS.PRESENT;
    if (enrollment.status === "ABSENT") return TRIAL_ATTENDANCE_STATUS.ABSENT;
    
    // Enrollment ativo que ainda não teve chamada
    return TRIAL_ATTENDANCE_STATUS.PENDING;
};
